export default {
    "/": {
        "title": "Taoify - Cross-Border E-Commerce Platform | Sell Chinese Goods Globally",
        "desc": "Taoify puts store building, translation, listing, logistics, payments and marketing in one dashboard, with 18 AI staff members and 20 languages."
    },
    "/feature": {
        "title": "Features - Everything You Need to Run a Store · Taoify",
        "desc": "Store building, translation, listing, shipping, payments and marketing - 15 modules in one dashboard. No more stitching tools together."
    },
    "/ai-staff": {
        "title": "AI Staff - 18 AI Employees Working on Traffic · Taoify",
        "desc": "5 growth AI staff solve \"no visitors\": 12-point store audit, 30-day marketing plan, one product rewritten for 9 channels, and automated emails that bring buyers back."
    },
    "/logistics": {
        "title": "Cross-Border Logistics - From Your Hands to Your Customer · Taoify",
        "desc": "First mile, customs, trunk lines and last-mile delivery. Yunexpress, Yanwen and 4PX integrated - labels, tracking and exceptions in one dashboard."
    },
    "/payment": {
        "title": "Payments - Let Customers Pay Their Way · Taoify",
        "desc": "PayPal, Stripe, cards and Alipay ready to use. Collect in foreign currencies, withdraw in CNY, T+7 settlement with transparent fees."
    },
    "/pricing": {
        "title": "Pricing - Subscription Plans + Tiered Commission · Taoify",
        "desc": "Subscription plans from $15/month with tiered commission as low as 3%. Quarterly and yearly billing save more."
    },
    "/cases": {
        "title": "Seller Stories - Same Playbook, Different Starting Points · Taoify",
        "desc": "Jewelry from Yiwu, 3C from Shenzhen, apparel from Guangzhou, plus sellers from Germany, the US and France - six stories, one playbook."
    },
    "/sign-up": {
        "title": "Sign Up - Taoify Store Registration",
        "desc": "Build your branded store in 10 minutes. Zero code, full-feature trial. Register now and start your cross-border journey."
    },
    "/for-china-sellers": {
        "title": "For Sellers in China - You Pick Products, We Handle the Rest · Taoify",
        "desc": "Store setup, translation, shipping rates, labels and customer replies - the platform does the busywork. Subscription + tiered commission from 3%."
    },
    "/for-global-sellers": {
        "title": "For Global Sellers: Source from China, Sell in Your Own Store · Taoify",
        "desc": "No inventory, no stock: list products from Chinese supply chains and ship directly from China when customers order. BuyLink turns 1688 and Taobao links into your products."
    },
    "/template-index": {
        "title": "Theme Marketplace - Taoify Professional Website Templates",
        "desc": "Professional theme templates for any project. Free industry templates with customizable branding and features."
    },
    "/question": {
        "title": "Help Center - Find Answers First · Taoify",
        "desc": "Store setup, themes, listings, orders and logistics, payments, marketing and account permissions - FAQs by category, plus tickets."
    },
    "/about-us": {
        "title": "About Taoify · Our Mission and Vision",
        "desc": "Taoify is an all-in-one platform for cross-border sellers, integrating website building, translation, product listing, logistics, payment, and marketing in one dashboard."
    },
    "/privacy-policy": {
        "title": "Privacy Policy · Taoify",
        "desc": "How Taoify collects, uses, stores, and protects your personal information, and the rights you have over your data."
    },
    "/terms-service": {
        "title": "Terms of Service · Taoify",
        "desc": "The terms and conditions for using Taoify's platform services: accounts, stores, orders, payments, and liability."
    },
    "/consumer-agreement": {
        "title": "Refund Policy · Taoify",
        "desc": "Rules for refunds and after-sales service on the Taoify platform: Conditions for application, processing times, and methods of receiving your refund."
    },
    "/user-agreement": {
        "title": "User Agreement · Taoify",
        "desc": "Please read the account registration, store operation guidelines, and platform service descriptions before registering and using Taoify."
    }
}
